import { Component } from 'react';
import L from 'leaflet';
import PropTypes from 'prop-types';

import LeafletPropTypes from '../PropTypes';

import EventHandlerMixin from '../mixins/EventHandlerMixin';
import PropertyHelperMixin from '../mixins/PropertyHelperMixin';
import LeafletComponentMixin from '../mixins/LeafletComponentMixin'; // TODO: kill this
import LoadingImageOverlay from './LoadingImageOverlay';

import omit from 'lodash/omit';

// TODO -- Is this class needed? Can it be combined with the inheriting class in
// calling code or something simpler? The structure is left over from ReactLeaflet.

// Brief explanation of this weird class - it does not render the DOM elements for the map, but instead tracks state
// that is expected to affect rendering and tries to get Leaflet to behave as though part of the React lifecycle.
class ImageLayer extends Component {

  constructor(props) {
    super(props);
    // TODO: kill these mixins and this fake mixin use
    Object.assign(this, EventHandlerMixin);
    Object.assign(this, PropertyHelperMixin);
    Object.assign(this, LeafletComponentMixin);

    this.displayName = 'ImageLayer';
    this.updatableProps = { // any prop not here will not trigger re-renders on changes
      opacity: function (layer) {
        layer.setOpacity(this.props.opacity / 100);
      },
      url: function (layer) {
        layer.setUrl(this.props.url);
      },
      bounds: function (layer) {
        layer.setBounds(this.props.bounds);
      }
    };
  }

  buildOptions() {
    return omit(this.props, ['map', 'url', 'bounds']);
  }

  generateComponent() {
    if (this.props.spinner) {
      return new LoadingImageOverlay(this.props.url, this.props.bounds,
        this.buildOptions());
    } else {
      return new L.imageOverlay(this.props.url, this.props.bounds); // eslint-disable-line new-cap
    }
  }

  addToMap(map, component) {
    component.addTo(map);
  }

  render() {
    return null;
  }
}

ImageLayer.defaultProps = {
  opacity: 100,
  spinner: false
};

ImageLayer.propTypes = {
  bounds: LeafletPropTypes.LatLngBounds.isRequired,
  map: PropTypes.object,
  opacity: PropTypes.number,
  spinner: PropTypes.bool,
  spinnerOpts: PropTypes.object, // using npm module 'spin'
  url: PropTypes.string.isRequired
};

export { ImageLayer };
